import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPreview from './LandingPreview';
import About from './pages/About';
import Privacy from './pages/Privacy';
import Help from './pages/Help';
import ColorTest from './ColorTest';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPreview />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/help" element={<Help />} />
        {/* Dev-only design reference page — not linked anywhere publicly */}
        <Route path="/colortest" element={<ColorTest />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;